module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7869/js/img/SalesHub_Icon.svg"